import styled from 'styled-components';
import { rem } from 'polished';
import { TrimTitleSectionStyled } from '../../TrimTitleSectionStyled';

export const TrimTitleSectionStyledOVGB = styled(TrimTitleSectionStyled)`
    .title {
        font-size: ${rem(30)};
        font-weight: ${({ theme }) => theme.fontWeights.textExtraBold};
        text-transform: uppercase;
    }
  
    .subTitle {
        font-size: ${rem(24)};
        text-transform: capitalize;
    }
`;
